import { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faTh } from "@fortawesome/free-solid-svg-icons";

export type DisplayMode = "grid" | "list"
interface DisplayModeToggleProps {
  value: DisplayMode
  onChange: (value: DisplayMode) => void
}
export const DisplayModeToggle: FC<DisplayModeToggleProps> = props => {
  return <div>
    <ul className={"flex my-4"}>
      <li>
        <button type={"button"} onClick={() => props.onChange('grid')} className={`h-8 text-sm rounded-l-lg font-medium flex items-center px-3 border ${props.value === 'grid' ? 'bg-brand-100 text-brand-900 border-brand-500' : 'bg-slate-100 hover:bg-slate-200 cursor-pointer text-slate-900 border-transparent'}`}>
          <FontAwesomeIcon icon={faTh} />
        </button>
      </li>
      <li>
        <button type={"button"} onClick={() => props.onChange('list')} className={`h-8 text-sm rounded-r-lg font-medium flex items-center px-3 border ${props.value === 'list' ? 'bg-brand-100 text-brand-900 border-brand-500' : 'bg-slate-100 hover:bg-slate-200 cursor-pointer text-slate-900 border-transparent'}`}>
          <FontAwesomeIcon icon={faList} />
        </button>
      </li>
    </ul>
  </div>
}
